import Vue from 'vue';
import Vuetify from 'vuetify';
import '@/styles/sass/app.scss';
import es from 'vuetify/es5/locale/es';
import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify, {
  theme: {
    // primary: '#00AFA8',
    // secondary: '#FFB94F',
    // accent: '#62DEA4',
    // error: '#f44336',
    // warning: '#FF9100',
    // info: '#263238',
    // success: '#00AFA8',
    background: '#ECEFF1',
    surface: '#ffffff',
    primary: '#52d99f',
    secondary: '#ffb100',
    error: '#f44336',
    info: '#b2c2cf',
    success: '#52d99f',
    warning: '#ffab40',
  },
  options: {
    customProperties: true,
  },
  iconfont: 'mdi',
  lang: {
    locales: {
      es,
    },
    current: 'es',
  },
});
